interface IProps {
  stroke?: string
  fill?: string
}

export default function IconRefresh({ fill = '#121212' }: IProps) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.99992 3.33301V0.833008L6.66659 4.16634L9.99992 7.49967V4.99967C12.7583 4.99967 14.9999 7.24134 14.9999 9.99967C14.9999 10.8413 14.7916 11.6413 14.4166 12.333L15.6333 13.5497C16.2833 12.5247 16.6666 11.308 16.6666 9.99967C16.6666 6.31634 13.6833 3.33301 9.99992 3.33301ZM9.99992 14.9997C7.24159 14.9997 4.99992 12.758 4.99992 9.99967C4.99992 9.15801 5.20825 8.35801 5.58325 7.66634L4.36659 6.44967C3.71659 7.47467 3.33325 8.69134 3.33325 9.99967C3.33325 13.683 6.31659 16.6663 9.99992 16.6663V19.1663L13.3333 15.833L9.99992 12.4997V14.9997Z'
        fill={fill}
      />
    </svg>
  )
}
